import MarketplaceWrapper from './MarketplaceWrapper';

export default MarketplaceWrapper;
